import { InstanceAPIType, AuthUserType } from "../../../Actions/Types"
import { Reducer } from "redux"
import { AuthAction } from "../../Auth"
import { APIAppMetricModel } from "../../../Models/API/AppMetricModel"
import { updateAt } from "../../../Helpers/Functions/reducer"

export interface IAppInstanceCustomizeState {
    [appID: string]:
        | {
              latestMetrics: APIAppMetricModel[]
              attrIdsToOptimize: string[]
              qualityAttrIdToOptimize?: string
          }
        | undefined
}

export type AppInstanceCustomizeState = IAppInstanceCustomizeState

interface IAppInstanceCustomizeLatestFetchedAction {
    type: InstanceAPIType.customizeMetrics_latestFetched
    payload: {
        appID: string
        metrics: APIAppMetricModel[]
    }
}

interface IAppInstanceCustomizeChooseMetricToOptimize {
    type: InstanceAPIType.customizeMetrics_chooseMetricToOptimize
    payload: {
        appID: string
        attrIds: string[]
    }
}

interface IAppInstanceCustomizeChooseQualityMetricToOptimize {
    type: InstanceAPIType.customizeMetrics_chooseQualityMetricToOptimize
    payload: {
        appID: string
        attrId?: string
    }
}

export type AppInstanceCustomizeAction =
    | IAppInstanceCustomizeLatestFetchedAction
    | IAppInstanceCustomizeChooseMetricToOptimize
    | IAppInstanceCustomizeChooseQualityMetricToOptimize

const initialState: AppInstanceCustomizeState = {}

export const AppInstanceCustomizeReducer: Reducer<
    AppInstanceCustomizeState,
    AppInstanceCustomizeAction | AuthAction
> = (state = initialState, action): AppInstanceCustomizeState => {
    switch (action.type) {
        case InstanceAPIType.customizeMetrics_latestFetched:
            return {
                ...state,
                [action.payload.appID]: {
                    latestMetrics: action.payload.metrics,
                    attrIdsToOptimize: [],
                    qualityAttrIdToOptimize: undefined
                }
            }
        case InstanceAPIType.customizeMetrics_chooseMetricToOptimize:
            return updateAt(state, action.payload.appID, entry =>
                entry === undefined
                    ? undefined
                    : {
                          ...entry,
                          attrIdsToOptimize: action.payload.attrIds
                      }
            )
        case InstanceAPIType.customizeMetrics_chooseQualityMetricToOptimize:
            return updateAt(state, action.payload.appID, entry =>
                entry === undefined
                    ? undefined
                    : {
                          ...entry,
                          qualityAttrIdToOptimize: action.payload.attrId
                      }
            )
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
